
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("eDZOV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fe81b385c24e2ef2$export$2e2bcd8739ae039);

var $gygXF = parcelRequire("gygXF");

var $innKU = parcelRequire("innKU");

var $iD3ui = parcelRequire("iD3ui");
var $fjI9S = parcelRequire("fjI9S");
var $aViOS = parcelRequire("aViOS");
var $brQrw = parcelRequire("brQrw");
var $51JwA = parcelRequire("51JwA");
var $2JiN0 = parcelRequire("2JiN0");
var $cQiRk = parcelRequire("cQiRk");

var $7jKGS = parcelRequire("7jKGS");

var $9ffp1 = parcelRequire("9ffp1");


var $963UN = parcelRequire("963UN");

var $1e3IC = parcelRequire("1e3IC");

var $Y6SnS = parcelRequire("Y6SnS");

var $hjYhT = parcelRequire("hjYhT");
const $fe81b385c24e2ef2$var$Login = ()=>{
    const navigate = (0, $9ffp1.useNavigate)();
    const dispatch = (0, $1e3IC.useDispatch)();
    const [rememberMe, setRememberMe] = (0, (/*@__PURE__*/$parcel$interopDefault($innKU))).useState(false);
    const [authState] = (0, $1e3IC.useSelector)((state)=>[
            state.auth
        ]);
    const [isMobileTablet] = (0, $cQiRk.useMediaQuery)("(max-width: 768px)");
    const basicValidation = $963UN.object().shape({
        userName: (0, $Y6SnS.yupEmail),
        password: (0, $Y6SnS.yupPassword)
    });
    const onSubmit = async (event)=>{
        dispatch((0, $Y6SnS.setPageLoading)({
            loading: true,
            loadingText: "Logging you in..."
        }));
        try {
            let result = await dispatch((0, $Y6SnS.loginProcure)(event.userName, event.password));
            if (result.status === 200) {
                localStorage.setItem("user_email", event.userName);
                dispatch((0, $Y6SnS.setPageLoading)({
                    loading: false,
                    loadingText: ""
                }));
            }
            navigate("/home");
            const uniqueUserId = await (0, $Y6SnS.get_doc)({
                doc: "User ID",
                fields: [
                    "id"
                ],
                filters: [
                    [
                        "name",
                        "=",
                        event.userName
                    ]
                ]
            });
            console.log("unique", uniqueUserId?.data.data[0]?.id);
            if (uniqueUserId?.status === 200) {
                dispatch({
                    type: (0, $Y6SnS.USERID_FETCH_SUCCESS),
                    payload: {
                        uniqueUserId: uniqueUserId?.data.data[0]?.id
                    }
                });
                window.dataLayer.push({
                    event: "User Login",
                    user_id: uniqueUserId?.data.data[0]?.id,
                    user_email: event.userName,
                    page_url: window.location.href,
                    page_name: window.location.pathname,
                    success: true
                });
                (0, $hjYhT.Mixpanel).identify(authState?.uniqueUserId);
                (0, $hjYhT.Mixpanel).track("logged In", {
                    user_id: uniqueUserId?.data.data[0]?.id,
                    user_email: event.userName
                });
            }
            navigate("/home");
            return; // Exit the function after successful login and navigation
        } catch (error) {
            (0, $hjYhT.Mixpanel).track("Unsuccessful login");
            window.dataLayer.push({
                event: "User Login",
                user_email: event.userName,
                page_url: window.location.href,
                page_name: window.location.pathname,
                success: false
            });
        }
        dispatch((0, $Y6SnS.setPageLoading)({
            loading: false,
            loadingText: ""
        }));
        (0, $Y6SnS.history).push("/home");
    };
    return /*#__PURE__*/ (0, $gygXF.jsx)((0, $iD3ui.Box), {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        h: "100%",
        bg: {
            base: "#0087ee",
            lg: "#fff"
        },
        children: /*#__PURE__*/ (0, $gygXF.jsxs)((0, $iD3ui.Box), {
            display: "flex",
            flexDir: "column",
            h: {
                base: "100%",
                lg: "auto"
            },
            w: {
                base: "100%",
                lg: "auto"
            },
            mt: {
                base: "2rem",
                lg: "0"
            },
            children: [
                /*#__PURE__*/ (0, $gygXF.jsxs)((0, $aViOS.Flex), {
                    mb: "1.5rem",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: {
                        base: "1rem",
                        lg: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $2JiN0.Text), {
                            textStyle: "primary.poster",
                            color: !isMobileTablet ? "#000" : "#fff",
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $2JiN0.Text), {
                            textStyle: "primary.text",
                            color: !isMobileTablet ? "#000" : "#fff",
                            children: "Welcome back!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $gygXF.jsx)((0, $iD3ui.Box), {
                    borderRadius: {
                        base: "1rem 1rem 0 0",
                        lg: "none"
                    },
                    bg: "#fff",
                    flexGrow: 1,
                    pt: {
                        base: "2rem",
                        lg: "0"
                    },
                    children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $7jKGS.Formik), {
                        initialValues: {
                            userName: "",
                            password: "",
                            remember: false
                        },
                        validationSchema: basicValidation,
                        onSubmit: onSubmit,
                        children: (formik)=>{
                            return /*#__PURE__*/ (0, $gygXF.jsx)((0, $7jKGS.Form), {
                                id: "signinbuyer",
                                className: "buyersignin",
                                children: /*#__PURE__*/ (0, $gygXF.jsxs)((0, $brQrw.Grid), {
                                    templateColumns: {
                                        xs: "repeat(1,1fr)"
                                    },
                                    gap: 5,
                                    children: [
                                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $51JwA.GridItem), {
                                            px: {
                                                base: "0.5rem",
                                                lg: 0
                                            },
                                            children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $Y6SnS.RenderTextField), {
                                                label: "Email",
                                                name: "userName",
                                                type: "email",
                                                placeholder: "name@company.com",
                                                isMandatory: true,
                                                _invalid: {
                                                    borderColor: "#0087ee"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gygXF.jsxs)((0, $51JwA.GridItem), {
                                            px: {
                                                base: "0.5rem",
                                                lg: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $gygXF.jsx)((0, $Y6SnS.RenderTextField), {
                                                    label: "Password",
                                                    name: "password",
                                                    type: "password",
                                                    placeholder: "********",
                                                    isMandatory: true,
                                                    _invalid: {
                                                        borderColor: "#0087ee"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $gygXF.jsx)((0, $aViOS.Flex), {
                                                    justifyContent: "space-between",
                                                    mt: {
                                                        base: 6,
                                                        lg: 1
                                                    },
                                                    children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $2JiN0.Text), {
                                                        _hover: {
                                                            textDecoration: "underline"
                                                        },
                                                        textStyle: "primary.secondaryText",
                                                        as: (0, $9ffp1.Link),
                                                        to: "/forgotPassword",
                                                        children: "Forgot password?"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $51JwA.GridItem), {
                                            children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $iD3ui.Box), {
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $fjI9S.Checkbox), {
                                                    isChecked: rememberMe,
                                                    onChange: ()=>setRememberMe((prevState)=>!rememberMe),
                                                    children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $2JiN0.Text), {
                                                        textStyle: "primary.secondaryText",
                                                        children: "Remember me"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $51JwA.GridItem), {
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            mt: {
                                                base: "2rem",
                                                lg: "3.375rem"
                                            },
                                            px: {
                                                base: "2rem",
                                                lg: 0
                                            },
                                            children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $Y6SnS.DarkButton), {
                                                type: "submit",
                                                id: "signinbuyerbtn",
                                                className: "buyersigninbtn",
                                                width: isMobileTablet ? "100%" : "23.75rem",
                                                height: "50px",
                                                children: "Log In",
                                                bg: "#0087ee",
                                                _hover: {
                                                    backgroundColor: "#0066B4"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $gygXF.jsx)((0, $51JwA.GridItem), {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $iD3ui.Box), {
                                                display: "flex",
                                                children: /*#__PURE__*/ (0, $gygXF.jsxs)((0, $2JiN0.Text), {
                                                    textStyle: "primary.secondaryText",
                                                    mt: "1em",
                                                    children: [
                                                        "Don't have an account?",
                                                        /*#__PURE__*/ (0, $gygXF.jsx)("span", {
                                                            children: /*#__PURE__*/ (0, $gygXF.jsx)((0, $2JiN0.Text), {
                                                                textStyle: "primary.link",
                                                                sx: {
                                                                    fontWeight: "600"
                                                                },
                                                                as: (0, $9ffp1.Link),
                                                                to: "/register",
                                                                children: "\xa0Sign Up"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $fe81b385c24e2ef2$export$2e2bcd8739ae039 = $fe81b385c24e2ef2$var$Login;

});


//# sourceMappingURL=Login.b1023504.js.map
